module.exports = __webpack_public_path__ + "build/img/pin.169704de.png";